<p class="flex-space-between" >
  <span class="key" [ngStyle] = "{'margin-bottom' : singleSectionCardData.key === 'NO-COMPAINES-COVERED' ? '20px' : '0'}" translate>DASHBOARD.SUMMARY.{{ singleSectionCardData.key }}</span>
  <span class="value" *ngIf="singleSectionCardData.value">
    <ng-container [ngTemplateOutlet]="singleDetailValue" [ngTemplateOutletContext]="{ detail: singleSectionCardData, sectionData: sectionData }"></ng-container>
  </span>
</p>

<ng-template let-sectionData="sectionData" let-detail="detail" #singleDetailValue>
  {{
    detail.compositeValue
      ? sectionData[detail.value[0].value] && sectionData[detail.value[1].value]
        ? sectionData[detail.value[0].value] + detail.separator + sectionData[detail.value[1].value]
        : sectionData[detail.value[0].value] || sectionData[detail.value[1].value] ? sectionData[detail.value[0].value]  || 
        sectionData[detail.value[1].value] : '-'
      : detail.type === 'number'
        ? sectionData[detail.value] === null || sectionData[detail.value] === undefined
          ? '-'
          : sectionData[detail.value]
        : !sectionData[detail.value] || sectionData[detail.value] === '0001-01-01'
          ? '-'
          : sectionData[detail.value]
  }}
</ng-template>
